// extracted by mini-css-extract-plugin
module.exports = {"buttonTopMargin":"Equipment_buttonTopMargin__2MRIe","highlight":"Equipment_highlight__2oAEk"};